export const getEnv = (key, isBool = false, throwOnFail = true) => {
  let variable =
    window.__ENV__?.[key] ??
    (typeof process !== undefined && process.env
      ? process.env[key]
      : undefined);
  if (throwOnFail && variable === undefined) {
    throw new Error(`Environment variable ${key} is not defined`);
  }

  if (isBool) {
    return (variable || "").toLowerCase() === "true";
  }

  return variable;
};

export const getNumericEnv = (key, throwOnFail = true) => {
  let number = null;

  const rawValue = getEnv(key, false, throwOnFail);

  if (typeof rawValue === "number" && !isNaN(rawValue)) {
    number = rawValue;
  } else if (typeof rawValue === "string") {
    const parsed = parseInt(rawValue, 10);
    if (!isNaN(parsed)) {
      number = parsed;
    }
  }

  if (number === null && throwOnFail) {
    throw new Error(`Environment variable ${key} is not a valid number`);
  }

  return number;
};
